// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Theater-module__theaterColumnWrapper--o53ZF {
  flex: 1 1 auto; /* Responsive width will be set via CSS class */
  background-color: var(--background-color);
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: hidden;
  height: 100vh;
  max-height: 100vh;
  scrollbar-width: none; /* hide scrollbar: Firefox */
}

.Theater-module__theaterColumnWrapper--o53ZF::-webkit-scrollbar {
  display: none; /* hide scrollbar: Safari and Chrome */
}

.Theater-module__theaterColumnWrapper--o53ZF.Theater-module__theaterColumnSizeNone--JsedC {
  width: var(--theater-width-none);
}

.Theater-module__theaterColumnWrapper--o53ZF.Theater-module__theaterColumnSizeSmall--DMMV2 {
  width: var(--theater-width-small);
}

.Theater-module__theaterColumnWrapper--o53ZF.Theater-module__theaterColumnSizeMedium--Jp6y2 {
  width: var(--theater-width-medium);
}

.Theater-module__theaterColumnWrapper--o53ZF.Theater-module__theaterColumnSizeLarge--VYiRz {
  width: var(--theater-width-large);
  overflow-y: hidden;
}

.Theater-module__theaterColumnWrapper--o53ZF.Theater-module__theaterColumnSizeFullscreen--uZ3Wi {
  width: var(--theater-width-fullscreen);
}

.Theater-module__theaterColumnWrapper--o53ZF::-webkit-scrollbar {
  display: none; /* hide scrollbar: Safari and Chrome */
  width: 100%;
}

.Theater-module__theaterCanvasPlaceholder--Pmfz8 {
  width: 100%;
  flex: 0 0 auto;
}

.Theater-module__theaterCanvas--IhaWe {
  flex: 0 0 auto;
  position: relative;
  overflow: hidden;
  border: 1px solid var(--theater-border-color);
}

.Theater-module__greyOut--aEPfF {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Theater-module__stage--cZJdb {
  transform-origin: top left;
  border: var(--thin) solid var(--theater-border-color);
  /* use important to corral Pixi */
  cursor: url("https://cs-curriculum-assets.artofproblemsolving.com/assets/theater-cursor.png"), default !important;
}

.Theater-module__stage--cZJdb.Theater-module__showCoordinates--x3Ijv {
  /* important to corral Pixi */
  cursor: url("https://cs-curriculum-assets.artofproblemsolving.com/assets/target-cursor.png") 14 14, crosshair !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Theater/Theater.module.scss"],"names":[],"mappings":"AAAA;EACC,cAAA,EAAA,+CAAA;EAEA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA,EAAA,4BAAA;AADD;;AAGA;EACC,aAAA,EAAA,sCAAA;AAAD;;AAEA;EACC,gCAAA;AACD;;AAEA;EACC,iCAAA;AACD;;AAEA;EACC,kCAAA;AACD;;AACA;EACC,iCAAA;EACA,kBAAA;AAED;;AAAA;EACC,sCAAA;AAGD;;AAAA;EACC,aAAA,EAAA,sCAAA;EACA,WAAA;AAGD;;AAAA;EACC,WAAA;EACA,cAAA;AAGD;;AAAA;EACC,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AAGD;;AAAA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;AAED;;AACA;EACC,0BAAA;EACA,qDAAA;EACA,iCAAA;EACA,iHAAA;AAED;;AAEA;EACC,6BAAA;EACA,wHACC;AAAF","sourcesContent":[".theaterColumnWrapper {\n\tflex: 1 1 auto; /* Responsive width will be set via CSS class */\n\n\tbackground-color: var(--background-color);\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\n\toverflow-y: hidden;\n\theight: 100vh;\n\tmax-height: 100vh;\n\tscrollbar-width: none; /* hide scrollbar: Firefox */\n}\n.theaterColumnWrapper::-webkit-scrollbar {\n\tdisplay: none; /* hide scrollbar: Safari and Chrome */\n}\n.theaterColumnWrapper.theaterColumnSizeNone {\n\twidth: var(--theater-width-none);\n}\n\n.theaterColumnWrapper.theaterColumnSizeSmall {\n\twidth: var(--theater-width-small);\n}\n\n.theaterColumnWrapper.theaterColumnSizeMedium {\n\twidth: var(--theater-width-medium);\n}\n.theaterColumnWrapper.theaterColumnSizeLarge {\n\twidth: var(--theater-width-large);\n\toverflow-y: hidden;\n}\n.theaterColumnWrapper.theaterColumnSizeFullscreen {\n\twidth: var(--theater-width-fullscreen);\n}\n\n.theaterColumnWrapper::-webkit-scrollbar {\n\tdisplay: none; /* hide scrollbar: Safari and Chrome */\n\twidth: 100%;\n}\n\n.theaterCanvasPlaceholder {\n\twidth: 100%;\n\tflex: 0 0 auto;\n}\n\n.theaterCanvas {\n\tflex: 0 0 auto;\n\tposition: relative;\n\toverflow: hidden;\n\tborder: 1px solid var(--theater-border-color);\n}\n\n.greyOut {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.stage {\n\ttransform-origin: top left;\n\tborder: var(--thin) solid var(--theater-border-color);\n\t/* use important to corral Pixi */\n\tcursor: url(\"https://cs-curriculum-assets.artofproblemsolving.com/assets/theater-cursor.png\"),\n\t\tdefault !important;\n}\n\n.stage.showCoordinates {\n\t/* important to corral Pixi */\n\tcursor:\n\t\turl(\"https://cs-curriculum-assets.artofproblemsolving.com/assets/target-cursor.png\")\n\t\t\t14 14,\n\t\tcrosshair !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"theaterColumnWrapper": `Theater-module__theaterColumnWrapper--o53ZF`,
	"theaterColumnSizeNone": `Theater-module__theaterColumnSizeNone--JsedC`,
	"theaterColumnSizeSmall": `Theater-module__theaterColumnSizeSmall--DMMV2`,
	"theaterColumnSizeMedium": `Theater-module__theaterColumnSizeMedium--Jp6y2`,
	"theaterColumnSizeLarge": `Theater-module__theaterColumnSizeLarge--VYiRz`,
	"theaterColumnSizeFullscreen": `Theater-module__theaterColumnSizeFullscreen--uZ3Wi`,
	"theaterCanvasPlaceholder": `Theater-module__theaterCanvasPlaceholder--Pmfz8`,
	"theaterCanvas": `Theater-module__theaterCanvas--IhaWe`,
	"greyOut": `Theater-module__greyOut--aEPfF`,
	"stage": `Theater-module__stage--cZJdb`,
	"showCoordinates": `Theater-module__showCoordinates--x3Ijv`
};
export default ___CSS_LOADER_EXPORT___;
